import BlockerResolved from './BlockerResolved';

export default BlockerResolved;
